import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, CreditCard, Users, Star, FileText, Zap, MapPin } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen pt-16 md:pt-24 pb-10 md:pb-16 overflow-hidden flex flex-col items-center justify-center pattern-lines" data-id="element-224">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] md:w-[800px] h-[600px] md:h-[800px] bg-rugby-gold-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-225" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-226">
        <div className="max-w-4xl mx-auto text-center" data-id="element-227">
          {/* TITLE — promesa de la landing */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="mb-6 md:mb-8" data-id="element-228">
            <h1 className="text-4xl sm:text-5xl md:text-7xl font-display text-white tracking-tight text-glow leading-[1.05]" data-id="element-229">
              De Reserva a Primera en Una Temporada
            </h1>
          </motion.div>

          {/* MOCKUP IMAGE — 70% size, between title and subtitle */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.7,
          delay: 0.2,
          type: 'spring'
        }} className="relative w-[70%] max-w-md md:max-w-lg mx-auto mb-6 md:mb-8" data-id="element-230">
            <div className="absolute inset-0 bg-glow-strong rounded-full blur-3xl opacity-50" data-id="element-231" />
            <motion.img src="https://cdn.magicpatterns.com/uploads/qcrqCDzqvqWDiQkv9w52VE/mockuprugby-Photoroom.png" alt="Rugby Pro Kit — vista previa del kit completo con tomos y bonos digitales" className="relative z-10 w-full h-auto drop-shadow-2xl" loading="eager" decoding="async"
          // @ts-ignore - fetchpriority is a valid HTML attribute
          fetchpriority="high" width={1280} height={1280} animate={{
            y: [0, -8, 0]
          }} transition={{
            duration: 4,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-232" />
          </motion.div>

          {/* SUBTITLE — subtitulo del modulo inicial */}
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="mb-6 md:mb-10" data-id="element-233">
            <p className="text-xl md:text-3xl font-serif italic text-rugby-gold-300 mb-3 md:mb-4" data-id="element-234">
              6 + 6 Tomos + Bonos
            </p>
            <p className="text-sm md:text-xl text-slate-300 max-w-2xl mx-auto leading-relaxed px-2" data-id="element-235">
              Tu plan completo de rugby listo: táctica, físico, mentalidad,
              nutrición, defensa y planificación. Sin estancarte en el club.
            </p>
          </motion.div>

          {/* Badges */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.5
        }} className="flex flex-wrap justify-center gap-2 md:gap-3 mb-6 md:mb-10" data-id="element-236">
            {[{
            icon: FileText,
            text: 'PDF Digital'
          }, {
            icon: Zap,
            text: 'Acceso Inmediato'
          }, {
            icon: Users,
            text: 'Amateur - Semiprofesional'
          }, {
            icon: MapPin,
            text: '🇦🇷 Todo Argentina'
          }].map((badge, i) => <div key={i} className="flex items-center gap-1.5 md:gap-2 bg-rugby-green-800/80 backdrop-blur-sm border border-rugby-green-700 py-1.5 md:py-2 px-3 md:px-4 rounded-lg text-xs md:text-sm font-medium text-slate-200" data-id="element-237">
                <badge.icon size={14} className="text-rugby-gold-400" data-id="element-238" />
                <span data-id="element-239">{badge.text}</span>
              </div>)}
          </motion.div>

          {/* CTA */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.6
        }} className="flex flex-col items-center" data-id="element-240">
            <motion.a href="#pricing" onClick={e => {
            e.preventDefault();
            document.getElementById('pricing')?.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }} whileHover={{
            scale: 1.04
          }} whileTap={{
            scale: 0.97
          }} className="group relative inline-flex items-center justify-center gap-3 bg-gradient-to-b from-rugby-gold-400 to-rugby-gold-600 text-rugby-green-950 font-display text-lg md:text-3xl py-4 md:py-5 px-6 md:px-10 rounded-xl shadow-[0_0_40px_rgba(212,175,55,0.4)] hover:shadow-[0_0_60px_rgba(212,175,55,0.6)] transition-shadow duration-300 w-full md:w-auto cursor-pointer no-underline" data-id="element-241">
              <span data-id="element-242">💥 QUIERO MI RUGBY PRO KIT AHORA</span>
              <div className="absolute inset-0 rounded-xl border-2 border-white/20 group-hover:border-white/40 transition-colors" data-id="element-243" />
            </motion.a>

            {/* Trust Row */}
            <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 md:gap-x-6 md:gap-y-3 mt-4 md:mt-6 text-xs md:text-sm text-slate-400" data-id="element-244">
              <span className="flex items-center gap-1.5" data-id="element-245">
                <ShieldCheck size={14} className="text-rugby-gold-500" data-id="element-246" />{' '}
                Garantía 7 días
              </span>
              <span className="flex items-center gap-1.5" data-id="element-247">
                <Lock size={14} className="text-rugby-gold-500" data-id="element-248" /> Pago seguro
              </span>
              <span className="flex items-center gap-1.5" data-id="element-249">
                <CreditCard size={14} className="text-rugby-gold-500" data-id="element-250" /> Mercado
                Pago
              </span>
              <span className="flex items-center gap-1.5" data-id="element-251">
                <Users size={14} className="text-rugby-gold-500" data-id="element-252" /> +500
                Rugbiers
              </span>
              <span className="flex items-center gap-1.5" data-id="element-253">
                <Star size={14} className="text-rugby-gold-500 fill-rugby-gold-500" data-id="element-254" />{' '}
                4.9 Rating
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}